<template>
  <div class="flex flex-col gap-2 w-full">
    <h1>Taxjar backup table</h1>
    <div class="flex flex-col gap-2 w-full">
      <button class="btn-dark-button w-60" @click="recreateTable">
        {{ recreating ? "Recreating..." : "Recreate table" }}
      </button>
      <div class="flex flex-col gap-2 w-full">
        <table
          class="w-full table table-auto border-collapse

"
        >
          <thead>
            <tr>
              <th>
                Country - code
              </th>
              <th>
                State - code
              </th>
              <th>
                Rate
              </th>
              <th>
                Nexus
              </th>
              <th>
                Shipping taxable
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in tableData" :key="index">
              <td class="text-center">
                {{ row.countryCode }}
              </td>
              <td class="text-center">
                {{ row.stateCode }}
              </td>
              <td class="text-center">
                {{ row.averageRate }}
              </td>
              <td
                :class="
                  row.nkrNexus === '0' ? 'text-red-500' : 'text-green-500'
                "
                class="font-bold text-center"
              >
                {{ row.nkrNexus === "0" ? "No" : "Yes" }}
              </td>
              <td
                :class="
                  row.taxableShipping === '0'
                    ? 'text-red-500'
                    : 'text-green-500'
                "
                class="font-bold text-center"
              >
                {{ row.taxableShipping === "0" ? "No" : "Yes" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getBackupTableTaxjar,
  recreateBackupTableTaxjar
} from "@/api/store/Taxjar";
export default {
  name: "Taxjar",
  data() {
    return {
      tableData: [],
      recreating: false
    };
  },
  mounted() {
    this.loadTable();
  },
  methods: {
    async loadTable() {
      try {
        const response = await getBackupTableTaxjar();
        this.tableData = response;
      } catch (error) {
        this.$toast.error("Error loading table data: " + error.message, {
          position: "top-right",
          duration: 5000
        });
      }
    },
    recreateTable() {
      if (this.recreating) {
        return;
      }
      this.recreating = true;
      recreateBackupTableTaxjar()
        .then(() => {
          this.$toast.success("Table recreated successfully", {
            position: "top-right",
            duration: 5000
          });
          this.loadTable();
        })
        .catch(error => {
          this.$toast.error("Error recreating table: " + error.message, {
            position: "top-right",
            duration: 5000
          });
        })
        .finally(() => {
          this.recreating = false;
        });
    }
  }
};
</script>
<style scoped>
.table {
  border: 1px solid #ccc;
  border-radius: 4px;
  overflow: hidden;
}
.table th,
.table td {
  padding: 8px;
  text-align: center;
  border-bottom: 1px solid #ccc;
}
.table th {
  background-color: #f2f2f2;
}
.table tr:hover {
  background-color: #f1f1f1;
}
.table tr:nth-child(even) {
  background-color: #f9f9f9;
}
.table tr:nth-child(odd) {
  background-color: #fff;
}
.table tr:nth-child(odd):hover {
  background-color: #f1f1f1;
}
</style>
